/* @flow */

const HereMapsThemes = {
  THEME_NORMAL_DAY: 'normal.day',
  THEME_NORMAL_DAY_GREY: 'normal.day.grey',
  THEME_NORMAL_NIGHT: 'normal.night',
  THEME_NORMAL_NIGHT_GREY: 'normal.night.grey',
  THEME_REDUCED_DAY: 'reduced.day',
  THEME_REDUCED_NIGHT: 'reduced.night'
};

export default HereMapsThemes;

export type $HereMapsTheme = $Values<typeof HereMapsThemes>;
